
import axios from "axios"
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      perPage: 100,
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      documento: null,
      tipoData: 'V',
      clienteId: null,
      registroSelecionadoId: null,
      paginaAtual: 1,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    PER_PAGE: state => { 
        return state.perPage
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    DOCUMENTO: state => {
        return state.documento
    },
    TIPO_DATA: state => {
        return state.tipoData
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
    SET_LISTA: (state, payload) => {
        state.lista = payload
    },
    SET_PER_PAGE: (state, payload) => {
        state.perPage = payload
    },
    SET_DT1: (state, payload) => {
        state.dt1 = payload
    },
    SET_DT2: (state, payload) => {
        state.dt2 = payload
    },
    SET_ID: (state, payload) => {
        state.id = payload
    },
    SET_CLIENTE_ID: (state, payload) => {
        state.clienteId = payload
    },
    SET_DOCUMENTO: (state, payload) => {
        state.documento = payload
    },
    SET_TIPO_DATA: (state, payload) => {
        state.tipoData = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
        state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL: (state, payload) => {
        state.paginaAtual = payload
    },
    SET_LIMPAR: (state, payload) => {
        state.id = null
        state.clienteId = null
        state.documento = null
        state.tipoData = 'V'
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
    }
  },
  /** ACTIONS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
          let documento = (getters.DOCUMENTO !== null ? getters.DOCUMENTO : '')
          let tipoData = (getters.TIPO_DATA !== null ? getters.TIPO_DATA : '')
          let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
          let dt2 = (getters.DT2 !== null ? getters.DT2 : '')

        let params = [];
        if (id) params.push(`id=${id}`)
        if (dt1) params.push(`dt1=${dt1}`)
        if (dt2) params.push(`dt2=${dt2}`)
        if (documento) params.push(`documento=${documento}`)
        if (tipoData) params.push(`tipoData=${tipoData}`)
        if (clienteId) params.push(`clienteId=${clienteId}`)
        let uri = `/api/protected/recebido/pesquisar` + (params.length ? `?${params.join('&')}` : '')
        axios
            .get(uri)
            .then(({ data, status }) => {
              // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
              if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                // Retorna os dados sem comitar, indicando que precisa de confirmação
                resolve({ 
                  data, 
                  status,
                  needsConfirmation: true,
                  count: data.length
                });
                return
              }
              
              // Carrega os dados normalmente
              commit("SET_LISTA", data)
              if (status === 200 || status === 201) {
                resolve({ data, status, needsConfirmation: false })
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/recebido-store.js